import api from './api';

export interface AdminDeviceToken {
  id: number;
  token: string;
  platform: 'android' | 'ios' | 'web';
  // Device.getId() з мобільного застосунку; null - web і старі версії застосунку. Кілька токенів з одним id - дубль.
  deviceId: string | null;
  updatedAt: string;
  createdAt: string;
  user: {
    id: number;
    name: string | null;
    surname: string | null;
    email: string;
    avatar?: string;
  };
}

export interface GetDevicesParams {
  page?: number;
  limit?: number;
  search?: string;
  platform?: 'android' | 'ios' | 'web';
}

export const adminDevicesService = {
  getDevices: async (params: GetDevicesParams = {}) => {
    // Список за правилами API: `{ success, data: [...], meta }` - масив у `data`, пагінація в `meta` (не `data.data`).
    const res = await api.get('/admin/devices', { params });
    return {
      data: (res.data?.data ?? []) as AdminDeviceToken[],
      meta: (res.data?.meta ?? { total: 0, page: 1, limit: params.limit ?? 25 }) as { total: number; page: number; limit: number },
    };
  },

  deleteDevice: async (id: number) => {
    await api.delete(`/admin/devices/${id}`);
  },

  testPush: async (id: number, title?: string, body?: string): Promise<{ success: boolean; platform: string; error?: string }> => {
    const res = await api.post(`/developer/test-push-to-device/${id}`, { title, body });
    return res.data?.data ?? res.data;
  },
};
